// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonHolyPlaceholder_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 1.15175L1.5 2.58032V5.41968L4 6.84825L6.5 5.41968V2.58032L4 1.15175ZM7.5 2L4 0L0.5 2V6L4 8L7.5 6V2Z" class="svg-bg"/>
  <path d="M5 4C5 4.55228 4.55228 5 4 5C3.44772 5 3 4.55228 3 4C3 3.44772 3.44772 3 4 3C4.55228 3 5 3.44772 5 4Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99999 1.16619L2 3.56619V8.43381L5.99999 10.8338L10 8.43381V3.56619L5.99999 1.16619ZM11 3L5.99999 0L1 3V9L5.99999 12L11 9V3Z" class="svg-bg"/>
  <path d="M7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.3035L3 5.16065V10.8394L8 13.6965L13 10.8394V5.16065L8 2.3035ZM15 4L8 0L1 4V12L8 16L15 12V4Z" class="svg-bg"/>
  <path d="M9.5 8C9.5 8.82843 8.82843 9.5 8 9.5C7.17157 9.5 6.5 8.82843 6.5 8C6.5 7.17157 7.17157 6.5 8 6.5C8.82843 6.5 9.5 7.17157 9.5 8Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.33238L4 7.13238V16.8676L12 21.6676L20 16.8676V7.13238L12 2.33238ZM22 6L12 0L2 6V18L12 24L22 18V6Z" class="svg-bg"/>
  <path d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 0L30 8V24L16 32L2 24V8L16 0ZM4 9.16065L16 2.3035L28 9.16064V22.8394L16 29.6965L4 22.8394V9.16065Z" class="svg-bg"/>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 2.3035L5 13.1606V34.8394L24 45.6965L43 34.8394V13.1606L24 2.3035ZM45 12L24 0L3 12V36L24 48L45 36V12Z" class="svg-bg"/>
  <path d="M28 24C28 26.2091 26.2091 28 24 28C21.7909 28 20 26.2091 20 24C20 21.7909 21.7909 20 24 20C26.2091 20 28 21.7909 28 24Z" class="svg-bg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 4.607L8 18.3213V45.6787L32 59.393L56 45.6787V18.3213L32 4.607ZM60 16L32 0L4 16V48L32 64L60 48V16Z" class="svg-bg"/>
  <path d="M37 32C37 34.7614 34.7614 37 32 37C29.2386 37 27 34.7614 27 32C27 29.2386 29.2386 27 32 27C34.7614 27 37 29.2386 37 32Z" class="svg-bg"/>
</svg>
`;
const _s80IconSvg = html `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 22.3213L40 4.607L71 22.3213V57.6787L40 75.393L9 57.6787V22.3213ZM40 0L75 20V60L40 80L5 60V20L40 0ZM40 46C43.3137 46 46 43.3137 46 40C46 36.6863 43.3137 34 40 34C36.6863 34 34 36.6863 34 40C34 43.3137 36.6863 46 40 46Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonHolyPlaceholder is a generated icon component.
 */
let IconCommonHolyPlaceholder = IconCommonHolyPlaceholder_1 = class IconCommonHolyPlaceholder extends IconBaseElement {
    render() {
        return html `${IconCommonHolyPlaceholder_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonHolyPlaceholder.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s80IconSvg],
    ['s80', _s80IconSvg],
]);
IconCommonHolyPlaceholder = IconCommonHolyPlaceholder_1 = __decorate([
    customElement('zui-icon-common-holy-placeholder')
], IconCommonHolyPlaceholder);
export { IconCommonHolyPlaceholder };
